import axios from "axios";
import qs from 'qs';
import { } from "@/components/plugin.js";
import { config } from '../puConfig'
const request = function (para) {
    var mepara = {
        url: `${vue.$config.API_URL}token=${vue.$store.state.token}&${para.url}` || '',
        para: para.para ? qs.stringify(para.para) : {},
        success: para.success || function (response) { },
        fail: para.fail || function (response) { },
        complete: para.complete || function (response) { },
    }
    axios.post(mepara.url, mepara.para, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
        .then(function (response) {
            var ponse = response.data;
            if (response.data.status === 200) {
                mepara.success(ponse.data || ponse);
            } else {
                if (response.data.status === 400) {
                    vue.$store.commit('updateWxId', '');
                    window.location.reload();
                } else if (response.data.status === 300) {
                    $plugin.error(response.data.datas);
                } else {
                    $plugin.error("服务器迷路了，请稍后再试！");
                }
            }
            mepara.complete(response.data);
        })
        .catch(function (error) {
            mepara.fail(error);
        });
}
/**
 * 全部自定义的请求发送
*/
const meAxios = {
    request
}
/**
 * request 因为是常用请求，也将可以单独使用
*/
export { meAxios, request };


// WEBPACK FOOTER //
// ./src/library/axios.js